import type { NetworkFields } from '@ms/yammer-graphql';

import type { Network } from '../../../state/types';

type ProcessNetwork = (value: NetworkFields) => Network;
export const processNetwork: ProcessNetwork = ({ id, displayName, permalink }) => ({
  id,
  displayName,
  permalink: permalink ?? '',
});
